module.exports = __webpack_public_path__ + "img/bell_5.2fb4b021.jpg";